import { IUser } from "../models/IUser";

export const formatClientName = (client: Partial<IUser>) => {
  return client.name ?? '';
};